// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credit-picker__popper.el-popover{padding:6px;border-radius:12px}", ""]);
// Exports
module.exports = exports;
